import React, { useState, useEffect } from 'react'
import { DappMenuSreen } from '../UI/DappMenuSreen'

import Avatar from '@mui/material/Avatar';


import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useForm } from '../../hooks/useForm';

import TextField from '@mui/material/TextField';
import { app, db, storage } from "../../firebaseConfig/firebaseConfig";
import { getFirestore, collection, getDocs, setDoc, addDoc, doc, getDoc,query, where,updateDoc } from 'firebase/firestore/lite';
import { experimentalStyled as styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import { Player, Controls } from '@lottiefiles/react-lottie-player';

import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(2),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));


export const DappContacts = () => {
    const [email, setemail] = useState('')
    const [password, setpassword] = useState('')
    const [name, setname] = useState('')
    const [contacts, setcontacts] = useState([]);
    const [viewcontacts, setviewcontacts] = useState([]);

    const myuser =  localStorage.getItem("uid");

    const [open, setOpen] = useState(false);

  const [open2, setOpen2] = useState(false);
    const [find, setFind] = useState(null);
    const [message,setmessage] = useState('');

    const handleClickOpen = () => {
      setOpen(true);
    };
  
    const handleClose = () => {
      setOpen(false);

      setFind(null);
    };


    const searchContact = async() => {
        console.log(email);
        if(email == localStorage.getItem("email")){
            return;
        }
        let validator = '';
        const citiesRef = collection(db, "users");
        const q = query(citiesRef, where("email", "==", localStorage.getItem("email")));
        const querySnapshot = await getDocs(q);

        const s = query(citiesRef, where("email", "==", email));
        const querySnapshots = await getDocs(s);
        querySnapshots.forEach(async(docs) => {
          console.log(docs, docs.exists,"dedededededede");
          console.log(docs.data(),"dioejroijeroicoie");
          validator = docs.id;

        })
        if(validator == ''){

          setFind("no data");
          return;

        }
       querySnapshot.forEach(async(docs) => {
            // doc.data() is never undefined for query doc snapshots
            console.log(docs.id, " => ", docs.data());
           
            let mycontacts = [];
            if(docs.data().contacts != undefined){
               mycontacts = docs.data().contacts; 
            }else if (docs.data().contacts == undefined){
           
            }
            mycontacts.push(validator)
            console.log(mycontacts,"aaaaa")
            const docRef = doc(db, "users", docs.id);
            const newData = {
                contacts: mycontacts,
            }
            await updateDoc(docRef, newData);

        setOpen2(true);
        setOpen(false);
        setmessage("Contacto añadido con exito");
        await getInfo();
        return

          });



    }


    const getInfo = async () => {
        console.log(myuser);
        const docRef = doc(db, "users", myuser);
        const docSnap = await getDoc(docRef);
        console.log(docSnap);


        if (!docSnap.exists) {
            console.log('No such document!');
        } else {
            console.log('Document data:', docSnap.data());
            //name = docSnap.data().name;
            let data = docSnap.data();
            console.log(data.contacts, "dede");
          
           if(data.contacts == undefined ){
                await setcontacts([])
            }else if(data.contacts.length > 0){
                let finalcontacts =[] ;
                setcontacts( ["ss"]);
             
                for(let contact of data.contacts){
                    const docRef = doc(db, "users", contact);
                    const docSnap = await getDoc(docRef);
                    console.log(docSnap.data())
                    finalcontacts.push(JSON.stringify(docSnap.data()));

                }
               await  setviewcontacts(finalcontacts);
            }

        }
    }

    const handleClose2 = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
    
        setOpen2(false);
      };


    useEffect(() => {
        getInfo();

    }, [false])




    const handleSubmit = async (e) => {
        console.log(name, email, password, "all that")
        //const task = StorageReference().child('profile/'+ new Date()).put(selectedImage)

        try {
            //await task
        } catch (err) {
            console.log(err)
        }

    }

    const action = (
        <React.Fragment>
          <Button color="secondary" size="small" onClick={handleClose}>
            
          </Button>
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleClose}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </React.Fragment>
      );


    return (
        <div>
            <div className="dapp_container2">
                <DappMenuSreen />
             

            <Snackbar
        open={open2}
        autoHideDuration={6000}
        onClose={handleClose2}
        message={message}
        action={action}
      />


                <h4 style={{ marginTop: "130px", textAlign: "center", fontSize: "28px" }}>Mis contactos </h4>
                <Button className="dapp__button" onClick={handleClickOpen} variant="contained">Añadir contacto </Button>

{contacts.length == 0  && 
<div className="dapp_container2">
                <Player
                        className="dapp__lottie"
                        autoplay
                        loop
                        src="../assets/gifts/36634-loading-experiments.json"
                    >
                    </Player>
                    <h3>Sin contactos</h3>
                    <Button className="dapp__button" onClick={handleClickOpen} variant="contained">Añadir contacto </Button>

                    </div>

}
{contacts.length > 0 &&
             <div className="dapp__contacts">
               
                <Box sx={{ flexGrow: 1 }}>
      <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 2, sm: 8, md: 12 }}>
        {Array.from(viewcontacts).map((_, index) => (
          <Grid item xs={2} sm={4} md={4} key={index}>
            <Item>

            <Avatar className="dapp__contactavatar" src={(JSON.parse(viewcontacts[index]))?.img}  alt={(JSON.parse(viewcontacts[index])).name} />
              <h4>{(JSON.parse(viewcontacts[index])).name} </h4>  
              <p>{(JSON.parse(viewcontacts[index])).email}</p>
              <p>{(JSON.parse(viewcontacts[index])).wallet}</p>
                </Item>
          </Grid>
        ))}
      </Grid>
    </Box>
    </div>
    }

<Dialog open={open} onClose={handleClose}>
        <DialogTitle>Añadir Contacto</DialogTitle>
        <DialogContent>
            {!find && 
          <DialogContentText>
            Introduce el email de tu contacto a buscar: 
          </DialogContentText>
           }
           {!find &&
          <TextField
            autoFocus
            margin="dense"
            id="email"
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setemail(e.target.value)}
            fullWidth
            variant="standard"
          />
        }

{find && 
          <DialogContentText>
            Usuario aún no registrado en Emyto: 
          </DialogContentText>
           }
           {find &&
         <p>Puedes mandar un link de invitación para que se registre en nuestra plataforma </p>
        }
       
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          {!find &&
          <Button onClick={searchContact}>Search</Button>
          }
        </DialogActions>
      </Dialog>

            </div>
        </div>
    )
}
